import React from "react";
import Switch from "@ls/react-switch";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectLookthruValue } from "state/selections/selector";
import { setLookthru } from "state/selections/actions";

const LookthruSwitch = (props) => {
  const value = useSelector(selectLookthruValue(SelectionState.UNCOMMITTED));
  const dispatch = useDispatch();
  const onChange = React.useCallback(
    (value) => {
      dispatch(setLookthru(value));
    },
    [dispatch]
  );
  return <Switch onChange={onChange} value={value} label="Lookthru" raised />;
};

export default LookthruSwitch;
